'use client'

import Link from 'next/link'
import { Card, CardDescription, CardHeader, CardTitle } from '~/components/ui/card'
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from '~/components/ui/drawer'
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '~/components/ui/sheet'
import { useBreakpoints } from '~/lib/useBreakpoints'
import { cn } from '~/lib/utils'

interface CourseCardProps {
  className?: string
  title: string
  description?: string
  pageId: string
}

export function CourseCard(props: CourseCardProps) {
  const breakpoints = useBreakpoints()

  if (breakpoints.md) {
    return (
      <Sheet>
        <SheetTrigger>
          <CourseCardTrigger className={props.className} description={props.description} title={props.title} />
        </SheetTrigger>

        <SheetContent className="w-full p-2 sm:max-w-4xl">
          <SheetHeader>
            <SheetTitle className="text-3xl text-pretty">
              Направление:
              {' '}
              {props.title}
            </SheetTitle>
          </SheetHeader>

          <PreviewFrame pageId={props.pageId} />
        </SheetContent>
      </Sheet>
    )
  }

  return (
    <Drawer>
      <DrawerTrigger>
        <CourseCardTrigger className={props.className} description={props.description} title={props.title} />
      </DrawerTrigger>

      <DrawerContent className="h-[90%]">
        <DrawerHeader className="flex h-full flex-col">
          <DrawerTitle className="text-3xl text-pretty">
            Направление:
            {' '}
            {props.title}
          </DrawerTitle>
          <PreviewFrame pageId={props.pageId} />
        </DrawerHeader>
      </DrawerContent>
    </Drawer>
  )
}

interface CourseCardLinkProps {
  className?: string
  title: string
  description?: string
  href: string
}

export function CourseCardLink(props: CourseCardLinkProps) {
  return (
    <Link href={props.href} prefetch>
      <CourseCardTrigger
        className={cn(
          'w-full max-w-full text-left hover:-translate-y-1 hover:shadow-md md:text-center',
          props.className,
        )}
        description={props.description}
        title={props.title}
      />
    </Link>
  )
}

interface CourseCardTriggerProps {
  className?: string
  title: string
  description?: string
}

export function CourseCardTrigger(props: CourseCardTriggerProps) {
  return (
    <Card
      className={cn('relative w-full text-center transition-all hover:-translate-y-1 hover:shadow-md', props.className)}
    >
      <CardHeader className="space-y-1">
        <CardTitle className="text-pretty">{props.title}</CardTitle>
        {props.description && <CardDescription>{props.description}</CardDescription>}
      </CardHeader>
    </Card>
  )
}

interface PreviewFrameProps {
  pageId: string
}

function PreviewFrame(props: PreviewFrameProps) {
  return (
    <div className="flex h-full flex-col pt-4">
      <div className="-mb-1 w-full space-y-2 rounded-t-lg bg-muted px-4 py-4 pb-5">
        <p className="font-medium">
          Авторизуйтесь, чтобы открыть все материалы
        </p>

        {/* <TelegramLoginButton /> */}
      </div>

      <iframe
        className="relative size-full overflow-hidden bg-background dark:bg-transparent"
        src={`/plus/embed/${props.pageId}`}
      />
    </div>
  )
}
